export default __webpack_public_path__ + "static/media/2025_Wan_et_al_2025_EcologicalMonographs.1acb68fa.pdf";